module.exports = __webpack_public_path__ + "img/permata.cf77fd28.png";